import { useMemo } from 'react';
import { z } from 'zod';
import { useTranslation } from 'react-i18next';

import { useForm } from '@pletly/ui';
import { passwordSchema } from '../consts';

const useEditPasswordForm = () => {
	const { t } = useTranslation();
	const formSchema = useMemo(
		() =>
			z
				.object({
					password: z.undefined().or(z.string().nonempty()),
					newPassword: passwordSchema,
					repeatPassword: z.string().nonempty(),
				})
				.refine((data) => data.newPassword === data.repeatPassword, {
					message: t('change-password.passwords-do-not-match'),
					path: ['repeatPassword'],
				})
				.refine((data) => data.password !== data.newPassword, {
					message: t('change-password.new-password-must-be-different-from-the-old-one'),
					path: ['newPassword'],
				}),
		[t],
	);

	return useForm(formSchema);
};

export { useEditPasswordForm };
